import { func, bool } from 'prop-types'
import { PureComponent } from 'react'
import { kuiperClassNames } from '../../utils'
import Cell from '../Cell'
import './styles.scss'

class ComponentCell extends PureComponent {
  static propTypes = {
    getCellContents: func.isRequired,
    onCellBlur: func.isRequired,
    tabbable: bool,
  }

  get tabIndex() {
    return this.props.tabbable ? 0 : -1
  }

  render() {
    return (
      <Cell
        {...this.props}
        onBlur={this.props.onCellBlur}
        className={kuiperClassNames('component-cell')}
      >
        <div className={kuiperClassNames('focusable')} tabIndex={this.tabIndex}>
          {this.props.getCellContents(this.props)}
        </div>
      </Cell>
    )
  }
}

export default ComponentCell
